import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import InvitationCopyMenuItem from "@/v2-backoffice-client/invitation/InvitationCopyMenuItem"
import InvitationResendMenuItem from "@/v2-backoffice-client/invitation/resend/InvitationResendMenuItem"
import InvitationRemoveMenuItem from "@/v2-backoffice-client/invitation/remove/InvitationRemoveMenuItem"
import InvitationUpdateMenuItem from "@/v2-backoffice-client/invitation/update/InvitationUpdateMenuItem"
import type { InvitationFragment } from "@/v2-backoffice-client/invitation/__types__/invitation.fragment"

export type InvitationTableRowToolbarProps = {
  invitation: InvitationFragment
}

function InvitationTableRowToolbar(props: InvitationTableRowToolbarProps) {
  const { invitation } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <InvitationCopyMenuItem invitation={invitation} />
        <InvitationResendMenuItem invitationId={invitation.Id} />
        <InvitationUpdateMenuItem invitation={invitation} />
        <ActionMenu.Separator />
        <InvitationRemoveMenuItem invitationId={invitation.Id} />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default InvitationTableRowToolbar
